import { render, staticRenderFns } from "./KyanAnimatie.vue?vue&type=template&id=2a21da61&"
import script from "./KyanAnimatie.vue?vue&type=script&lang=js&"
export * from "./KyanAnimatie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports